import axios from 'axios'
import Vue from 'vue'

import store from '../plugins/store'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/api'
})

axiosInstance.interceptors.request.use(config => {
    let token = store.getters['account/token']

    if(token !== null) {
        config.headers.Authorization = 'Bearer ' + token
    }

    return config
}, error => {
    return Promise.reject(error)
})

axiosInstance.interceptors.response.use(response => {
    let body = response.data

    if (body.code !== undefined) {
        let code = body.code

        if(code === 'INVALID_TOKEN' || code === 'EXPIRED_TOKEN' || code === 'NOT_FOUND_TOKEN') {
            Vue.prototype.$global.$emit('redirect-login')

            localStorage.clear()
            window.location.href = '/'
        }
    }

    if(body.message) {
        if(!body.success) {
            Vue.prototype.$global.$emit('handled-error', { body: body })
        } else {
            Vue.prototype.$global.$emit('success-request', { body: body })
        }
    }

    return { body: body }
}, error => {

    if(error.response !== undefined && error.response.status !== 401) {
        Vue.prototype.$global.$emit('unhandled-error', error)
    }

    return Promise.reject(error)
})

export default axiosInstance